import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { AdminTemplate, Button, MerchantListingTable, MerchantBlackListCheckModal } from "../../components";

export const MerchantList = () => {
  const navigate = useNavigate();

  const handleAddButton = () => navigate("/merchant-management/merchant-identification");

  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <AdminTemplate
      headerProps={{
        headerTitle: "İşyeri Listeleme",
        onClickAddButton: handleAddButton,
        extraElement: <>
          <Button
            onClick={() => setIsModalOpen(true)}
            size="small"
            variant="contained"
            text="Kara Liste Sorgulama"
          />
        </>,
      }}
    >
      <MerchantListingTable onRowClick={() => { }} />
      <MerchantBlackListCheckModal
        isOpen={isModalOpen}
        handleClose={() => setIsModalOpen(false)}
      />
    </AdminTemplate>
  );
};
